export function zeroPadding(num, len) {
  var res = String(num);

  while (res.length < len) {
    res = '0' + res;
  }

  return res;
}